import { render } from "./AboutProduct.vue?vue&type=template&id=327dcd20"
import script from "./AboutProduct.vue?vue&type=script&lang=js"
export * from "./AboutProduct.vue?vue&type=script&lang=js"

import "./AboutProduct.vue?vue&type=style&index=0&id=327dcd20&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__